import React, { useContext } from 'react';
import Cookies from 'js-cookie';
import UserProvider from '../../context/UserContext';
import '../../dash.css'

const NavBarDash = () => {
    const Data = useContext(UserProvider.context);
    const userData = Data.user

    const id = userData.id
    const avatar = userData.avatar
    let avatarUrl = ''
    
    if(avatar == null) {
        avatarUrl = 'https://cdn.discordapp.com/app-icons/708966884254547978/f053c129acb0da07a723a667669bd6d2.png'
    }
    else {
         avatarUrl = 'https://cdn.discordapp.com/avatars/'+id+'/'+avatar+'.png'
    }

    function ShowLogout(){
        var x = document.getElementById("logout");
        if (x.style.display === "block") {
            x.style.display = "none";
        } else {
            x.style.display = "block";
        }
    }

    return(
        <nav className="dash-navbar navbar-collapse">
            <button className="nav-right logout-button" onClick={ShowLogout}>
                <div className="avatar  nav-right" >
                    <img alt="" src={avatarUrl}></img>
                </div>
                <div id="logout" className="hidden-menu">
                    <div className="logout-menu">
                        <button className="logout-button" onClick={() => {
                            Cookies.remove('user_data', { path: '/', domain: '.infinitbot.com' })
                            Cookies.remove('session', { path: '/', domain: '.infinitbot.com' })
                            window.location.replace('/')
                        }}>
                            <h5 className="logout-text">Logout</h5>
                        </button>
                    </div>
                </div>
            </button>
        </nav>
    )
};

export default NavBarDash;